import React, { Component } from "react";
import { observer } from "mobx-react";
import { computed } from "mobx";
import PropTypes from "prop-types";
import moment from "moment";
import { Button, Form, Select, Table } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import OtherProduct from "~/models/OtherProduct";
import CommonHelper from "~/utils/CommonHelper";
import SubscriptionItem from "~/models/Subscription/SubscriptionItem";
import UiMeet3dPackageInfos from "~/constants/UiMeet3d/UiMeet3dPackageInfos";

@observer
class SubscriptionEditFormTableRow extends Component {
  @computed
  get changedDuringCurrentBillingCycle() {
    const { existingSubscriptionItem } = this.props;

    return (
      existingSubscriptionItem &&
      typeof existingSubscriptionItem !== "undefined" &&
      typeof existingSubscriptionItem.startedDts !== "undefined" &&
      existingSubscriptionItem.startedDts !== null &&
      existingSubscriptionItem.startedDts.isAfter(moment())
    );
  }

  render() {
    const {
      t,
      otherProduct,
      index,
      quantity,
      quantityOptions,
      setQuantityAtPropertySubscriptionItems,
      removeSubscriptionItemCallback,
      length,
    } = this.props;

    return (
      <>
        <Table.Row disabled={this.changedDuringCurrentBillingCycle}>
          <Table.Cell>{t(UiMeet3dPackageInfos[otherProduct.otherProductId].nameTranslationKey)}</Table.Cell>
          <Table.Cell>
            <Form.Field
              control={Select}
              name="quantity"
              value={quantity}
              options={quantityOptions}
              onChange={(_event, { value }) => setQuantityAtPropertySubscriptionItems(index, value)}
              disabled={this.changedDuringCurrentBillingCycle}
            />
          </Table.Cell>
          <Table.Cell>{CommonHelper.currencyFormat(parseFloat(otherProduct.price))}</Table.Cell>
          <Table.Cell textAlign="left">
            {CommonHelper.currencyFormat(quantity * parseFloat(otherProduct.price))}
          </Table.Cell>
          <Table.Cell>
            <Button
              icon="trash"
              color="red"
              disabled={length === 1 || this.changedDuringCurrentBillingCycle}
              onClick={() => removeSubscriptionItemCallback(index)}
            />
          </Table.Cell>
        </Table.Row>
      </>
    );
  }
}

SubscriptionEditFormTableRow.propTypes = {
  t: PropTypes.func.isRequired,
  existingSubscriptionItem: PropTypes.instanceOf(SubscriptionItem),
  otherProduct: PropTypes.instanceOf(OtherProduct),
  index: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
  quantityOptions: PropTypes.array.isRequired,
  setQuantityAtPropertySubscriptionItems: PropTypes.func.isRequired,
  removeSubscriptionItemCallback: PropTypes.func.isRequired,
  length: PropTypes.number.isRequired,
};

export default withTranslation()(SubscriptionEditFormTableRow);
